


























































































































import { Component, Mixins } from 'vue-property-decorator';
import { Profile, ListingStatus, WebsiteLevel } from 'client-website-ts-library/types';
import { API } from 'client-website-ts-library/services';
import { BlogFilter, ListingFilter, ListingOrderBy, TestimonialFilter, TestimonialOrderBy } from 'client-website-ts-library/filters';
import { AsyncView, RouteMeta } from 'client-website-ts-library/plugins';

import Masthead from '@/components/Common/Masthead.vue';
import Listings from '@/components/Listings.vue';
import TestimonialCards from '@/components/Testimonials/TestimonialCards.vue';
import Loader from '@/components/UI/Loader.vue';

import { AnalyticsEventObject } from 'client-website-ts-library/services/Analytics';
import Button from '@/components/UI/Button.vue';
import Blogs from '@/components/Blogs.vue';

@Component({
  components: {
    Masthead,
    Listings,
    TestimonialCards,
    Loader,
    Blogs,
  },
})
export default class AgentProfile extends Mixins(AsyncView) {
  public profile: Profile | null = null;

  public currentListingFilter: ListingFilter | null = null;

  public soldListingFilter: ListingFilter | null = null;

  public leasedListingFilter: ListingFilter | null = null;

  public testimonialFilter: TestimonialFilter | null = null;

  public blogFilter: BlogFilter | null = null;

  public hasSoldListings = true;

  public hasLeasedListings = true;

  public hasCurrentListings = true;

  public hasTestimonials = true;

  public hasBlogs = true;

  resolveId() {
    const { id } = this.$route.params;

    if (id.length === 36) {
      // If the ID is 36 long we'll treat it as a guid
      this.updateAgent(id);
    } else {
      API.Slugs.Resolve(id).then((resolved) => {
        if (resolved.Type === 'Profile') {
          this.updateAgent(resolved.Id);
        }
      });
    }
  }

  stripHtml(html: string): string {
    const el = document.createElement('div');

    el.innerHTML = html;

    return el.innerText;
  }

  head(): RouteMeta | null {
    if (this.profile === null) return null;

    let about = this.stripHtml(this.profile.AboutAgent);

    if (about.length > 156) {
      about = `${about.substring(0, 156)}...`;
    }

    return {
      title: `${this.profile.FullName} - ${this.profile.Position}`,
      description: about,
      image: this.profile.Photo ? this.profile.Photo.Preview.Url : undefined,
    };
  }

  updateAgent(id: string) {
    API.Profiles.Get(id).then((profile) => {
      this.profile = profile;

      this.$emit('updateView');

      this.currentListingFilter = new ListingFilter({
        SearchLevel: WebsiteLevel.Profile,
        SearchGuid: this.profile!.Id,
        Statuses: [
          ListingStatus.Current,
          ListingStatus.UnderContract,
        ],
        OrderByStatements: [
          ListingOrderBy.CreateDateDesc,
        ],
        PageSize: 4,
      });

      this.soldListingFilter = new ListingFilter({
        SearchLevel: WebsiteLevel.Profile,
        SearchGuid: this.profile!.Id,
        Statuses: [
          ListingStatus.Sold,
        ],
        OrderByStatements: [
          ListingOrderBy.LastUpdatedDateDesc,
        ],
        PageSize: 4,
      });

      this.leasedListingFilter = new ListingFilter({
        SearchLevel: WebsiteLevel.Profile,
        SearchGuid: this.profile!.Id,
        Statuses: [
          ListingStatus.Leased,
        ],
        OrderByStatements: [
          ListingOrderBy.LastUpdatedDateDesc,
        ],
        PageSize: 4,
      });

      this.testimonialFilter = new TestimonialFilter({
        SearchLevel: WebsiteLevel.Profile,
        SearchGuid: this.profile!.Id,
        OrderByStatements: [
          TestimonialOrderBy.CreateDateDesc,
        ],
      });

      this.blogFilter = new BlogFilter({
        SearchLevel: WebsiteLevel.Profile,
        SearchGuid: this.profile!.Id,
      });
    });
  }

  mounted() {
    this.resolveId();
  }

  getAnalyticsData(): AnalyticsEventObject | null {
    if (this.profile === null) return null;

    return AnalyticsEventObject.FromProfile(this.profile);
  }
}
